export const getPaymentIcon = (brand) => {
  const icon = `fa-cc-${brand.toLowerCase().replace(' ', '').replace('americanexpress', 'amex')}`;
  return icon;
};
